import { OnInit, Output, EventEmitter, ViewChild, Input, Directive } from '@angular/core';
import { NgbModal, NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../data/data.service';

@Directive()

export abstract class ModalBaseComponent<T> implements OnInit {

  constructor(protected modalService: NgbModal, protected dataService: DataService) { }

  data: T;
  modal: NgbActiveModal;
  closeResult: string;
  @Output() dataRefresh = new EventEmitter();
  @ViewChild('content', { static: false })
  content: any;
  @Input() openModalButtonVisible: boolean;
  modalHeader: string;
  submitButtonText: string;
  wasOpenedForEdit: boolean;
  isWaiting: boolean;

  ngOnInit() {
  }

  open(content) {
    var modalRef = this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: "lg",
      windowClass: 'custom-class'
    });

    this.modal = modalRef;

    modalRef.result.then((result) => {
      this.initializeNewData();
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.initializeNewData();
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openForEdit(toEdit: T) {
    this.wasOpenedForEdit = true;
    this.data = JSON.parse(JSON.stringify(toEdit));
    this.submitButtonText = 'Save';
    this.open(this.content);
  }

  openForNew() {
    this.wasOpenedForEdit = false;
    this.submitButtonText = 'Add';
    this.initializeNewData();
    this.open(this.content);
  }

  onModalClosed(result: any) {

  }

  saveComplete(result: any) {
    if (result === undefined) this.modal.close();
    if (result) {
      this.dataRefresh.next();
      this.modal.close();
      this.initializeNewData();
    }
    this.isWaiting = false;
  }

  abstract initializeNewData(): void;

  modalSubmitted() {
    if (this.wasOpenedForEdit) {
      this.saveEdit();
    } else {
      this.saveNew();
    }
  }

  abstract isInputValid(): boolean;
  abstract saveEdit(): void;
  abstract saveNew(): void;
}
